import React from 'react';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div className="pt-[72px] bg-[#faf8f6]">
      <Contact />
    </div>
  );
};

export default ContactPage;
